<template>
    <div class="max-w-4xl mx-auto p-6 bg-white shadow-lg my-32 rounded-xl">
        <h1 class="text-3xl font-bold mb-6 text-center">Conditions Générales de Vente (CGV) – MyProfolia</h1>

        <div v-for="section in sections" :key="section.id" class="mb-6">
            <h2 class="text-xl font-semibold mb-2">{{ section.title }}</h2>
            <p v-for="(paragraph, index) in section.content" :key="index" class="mb-2 leading-relaxed">
                {{ paragraph }}
            </p>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            sections: [
                {
                    id: 1,
                    title: "1. Objet",
                    content: [
                        "Les présentes Conditions Générales de Vente (CGV) régissent la fourniture par MyProfolia du service de création et gestion d’une page professionnelle personnalisée regroupant les coordonnées et informations clés de l’entreprise (nom, adresse, logo, activité, description, horaires, réseaux sociaux, tarifs)."
                    ]
                },
                {
                    id: 2,
                    title: "2. Acceptation des CGV",
                    content: [
                        "Toute commande d’abonnement implique l’acceptation sans réserve des présentes CGV. Le client déclare en avoir pris connaissance et les accepter avant la souscription."
                    ]
                },
                {
                    id: 3,
                    title: "3. Description du service",
                    content: [
                        "My Profolia permet la création, la personnalisation et la gestion d’une page professionnelle accessible en ligne, centralisant les informations essentielles et coordonnées de l’entreprise.",
                        "Le service est activé immédiatement après paiement, et le client peut prévisualiser sa page avant validation finale."
                    ]
                },
                {
                    id: 4,
                    title: "4. Abonnements et tarifs",
                    content: [
                        "Abonnement mensuel sans engagement : 5,99 € /mois",
                        "Abonnement annuel avec engagement 1 an : 59,99 € /an",
                        "Les tarifs sont susceptibles d’évoluer. Toute modification sera notifiée au client au moins 30 jours avant application.",
                        "Le paiement s’effectue exclusivement via Stripe par carte bancaire et est renouvelable automatiquement selon la périodicité choisie (mensuelle ou annuelle), jusqu’à résiliation par le client.",
                        "Aucune TVA n’est facturée conformément à l’article 293 B du Code Général des Impôts (CGI). Le client ne peut donc pas récupérer de TVA sur les sommes versées."
                    ]
                },
                {
                    id: 5,
                    title: "5. Modalités de paiement",
                    content: [
                        "Le paiement est dû à la souscription puis prélevé automatiquement selon la périodicité choisie (mensuelle ou annuelle).",
                        "Les paiements sont sécurisés et conformes aux normes bancaires (Stripe, PCI DSS).",
                        "En cas de non-paiement, l’accès au service sera suspendu sans préavis jusqu’à régularisation.",
                        "Aucune TVA n’est facturée conformément à l’article 293 B du Code Général des Impôts (CGI)."
                    ]
                },
                {
                    id: 6,
                    title: "6. Durée, renouvellement et résiliation",
                    content: [
                        "L’abonnement mensuel est sans engagement et peut être résilié à tout moment via le bouton de résiliation disponible dans l’espace client. La résiliation prend effet à la fin de la période de facturation en cours.",
                        "L’abonnement annuel est conclu pour une durée minimale de 1 an. Il se renouvelle automatiquement pour des périodes successives d’un an, sauf résiliation notifiée par le client au moins 30 jours avant la date anniversaire via l’espace client.",
                        "La résiliation se fait directement via l’espace client en cliquant sur le bouton de résiliation."
                    ]
                },
                {
                    id: 7,
                    title: "7. Droit de rétractation",
                    content: [
                        "Conformément à la législation française sur les services numériques fournis immédiatement, le client renonce expressément à son droit de rétractation de 14 jours en acceptant la fourniture immédiate du service. Le client est informé que dès la souscription et l’activation de son accès, le service est pleinement fourni."
                    ]
                },
                {
                    id: 8,
                    title: "8. Obligations de MyProfolia",
                    content: [
                        "Fournir un accès continu au service, sauf interruptions pour maintenance ou cas de force majeure.",
                        "Assurer la confidentialité et la sécurité des données personnelles, conformément au RGPD.",
                        "Mettre à jour régulièrement la plateforme pour garantir sa performance et sécurité."
                    ]
                },
                {
                    id: 9,
                    title: "9. Obligations du client",
                    content: [
                        "Fournir des informations complètes, exactes et à jour pour la création et gestion de la page professionnelle.",
                        "Utiliser le service conformément à sa finalité et aux dispositions légales.",
                        "Régler les sommes dues aux dates convenues.",
                        "Le client est seul responsable des informations légales, réglementaires, et de la véracité des données qu’il publie via le service MyProfolia."
                    ]
                },
                {
                    id: 10,
                    title: "10. Responsabilité",
                    content: [
                        "MyProfolia s’engage à fournir un service fiable, mais ne garantit pas une disponibilité ininterrompue.",
                        "La responsabilité de MyProfolia est limitée aux dommages directs et ne saurait être engagée pour des dommages indirects, perte de données ou conséquences liées à une mauvaise utilisation.",
                        "Le client est responsable de la sauvegarde de ses données."
                    ]
                },
                {
                    id: 11,
                    title: "11. Protection des données personnelles",
                    content: [
                        "Les données personnelles collectées sont traitées conformément à la politique de confidentialité et au RGPD. Pour plus d’informations, consulter notre Politique de confidentialité."
                    ]
                },
                {
                    id: 12,
                    title: "12. Propriété intellectuelle",
                    content: [
                        "MyProfolia conserve la propriété intellectuelle sur l’ensemble du service, ses éléments techniques, visuels, et logiciels.",
                        "Le client bénéficie d’un droit d’usage non exclusif et non transférable sur sa page professionnelle, uniquement pour l’utilisation prévue par le service."
                    ]
                },
                {
                    id: 13,
                    title: "13. Réclamations et médiation amiable",
                    content: [
                        "En cas de litige, le client est invité à contacter MyProfolia à l’adresse suivante : contact@myprofolia.com afin de tenter une résolution amiable. Nous nous engageons à répondre dans les meilleurs délais et à rechercher une solution satisfaisante pour les deux parties.",
                        "Si aucune solution amiable n’est trouvée, le client peut recourir à un médiateur de la consommation agréé. La liste des médiateurs disponibles est consultable sur : https://www.economie.gouv.fr/mediateurs-consommation. Le recours à la médiation est gratuit pour le client."
                    ]
                },
                {
                    id: 14,
                    title: "14. Modifications des CGV",
                    content: [
                        "MyProfolia se réserve le droit de modifier les présentes CGV. Toute modification sera communiquée au client au moins 30 jours avant son application."
                    ]
                },
                {
                    id: 15,
                    title: "15. Loi applicable et juridiction",
                    content: [
                        "Les présentes CGV sont régies par le droit français. Tout litige sera soumis à la compétence exclusive des tribunaux du ressort du siège social de MyProfolia."
                    ]
                }
            ]
        };
    }
};
</script>

<style scoped>
/* Ajout de style supplémentaire si nécessaire */
</style>